/**
 * @generated SignedSource<<50b61d3e627370ade8045d9389f5ac79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LibraryPostActionsRemoveXWCRecordingFromLibraryMutation$variables = {
  recordingId: string;
};
export type LibraryPostActionsRemoveXWCRecordingFromLibraryMutation$data = {
  readonly removeXwcRecordingFromLibrary: {
    readonly ok: boolean;
  } | null;
};
export type LibraryPostActionsRemoveXWCRecordingFromLibraryMutation = {
  response: LibraryPostActionsRemoveXWCRecordingFromLibraryMutation$data;
  variables: LibraryPostActionsRemoveXWCRecordingFromLibraryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recordingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "recordingId",
        "variableName": "recordingId"
      }
    ],
    "concreteType": "RemoveXwcRecordingFromLibrary",
    "kind": "LinkedField",
    "name": "removeXwcRecordingFromLibrary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LibraryPostActionsRemoveXWCRecordingFromLibraryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LibraryPostActionsRemoveXWCRecordingFromLibraryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "80e1962230a4b3aca96a259fe0a38c34",
    "id": null,
    "metadata": {},
    "name": "LibraryPostActionsRemoveXWCRecordingFromLibraryMutation",
    "operationKind": "mutation",
    "text": "mutation LibraryPostActionsRemoveXWCRecordingFromLibraryMutation(\n  $recordingId: ID!\n) {\n  removeXwcRecordingFromLibrary(recordingId: $recordingId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "068bc311db65c873954b3dacbd945eac";

export default node;
